import {
    bpmsResourcesManagerApi,
    documentTemplatesSettingsApi,
} from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class SettingsDocumentationTemplatesStoreClass extends BasicStore<any> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-61-document-templates.json';

    itemEditFormKey =
        'embedded:deployment:forms/bo/bo-52-edit-document-templates.json';

    api: BasicStoreApi<any> = {
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(formKey, options),
            );
        },
        loadItem: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                documentTemplatesSettingsApi.findAllDocumentTemplates(options),
            );
        },
        updateItem: (_, data, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                documentTemplatesSettingsApi.editDocumentTemplatesList(
                    data,
                    options,
                ),
            );
        },
    };
}

export const SettingsDocumentationTemplatesStore =
    new SettingsDocumentationTemplatesStoreClass();
